<template>
  <div v-if="active">
  <v-snackbar
    :bottom="true"
    :right="true"
    :multi-line="true"
    :timeout="0"
    v-model="showSnackbar"
  >
    {{ message }}
    <v-btn flat icon @click.native="showSnackbar = false">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
  <v-tooltip v-if="!showSnackbar" left>
    <v-btn
      slot="activator"
      color="info"
      dark
      fixed
      bottom
      right
      @click.native="showSnackbar = true"
      fab>
      <v-icon>lock_open</v-icon>
    </v-btn>
    <span>{{ message }}</span>
  </v-tooltip>
    </div>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
    },
    message: {
      type: String,
    },
  },
  data() {
    return {
      showSnackbar: true,
    };
  },
};
</script>
